import React, { useEffect, useState } from 'react'
import { Button, Cell, Checkbox, Divider, Grid, TextField } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import OdvEventSelect from '../OdvEventSelect'
import { DmcDatePicker } from '../../../common/DmcDatePicker/DmcDatePicker'
import OdvCollectionSelect from '../OdvCollectionSelect'
import OdvOrdinanceSelect from '../OdvOrdinanceSelect'
import DmcTemplePicker from '../../../common/DmcTemplePicker'

export default function OdmRecordForm({ handleSubmit, location, history }) {
  const searchParams = new URLSearchParams(location.search)
  const { t } = useTranslation()
  const initialState = {
    givenName: '',
    surname: '',
    eventType: '',
    date: '',
    dateRange: false,
    startDate: '',
    endDate: '',
    location: '',
    recordNbr: '',
    afNumber: '',
    collection: '',
    rfn: '',
    sourceBatch: '',
    batchNbr: '',
    ord: '',
    ordDate: '',
    ordDateRange: false,
    ordStartDate: '',
    ordEndDate: '',
    ordTemple: '',
  }
  const [query, setQuery] = useState({
    givenName: searchParams.get('givenName') || '',
    surname: searchParams.get('surname') || '',
    eventType: searchParams.get('eventType') || '',
    date: searchParams.get('date') || '',
    dateRange: searchParams.get('dateRange') || false,
    startDate: searchParams.get('startDate') || '',
    endDate: searchParams.get('endDate') || '',
    location: searchParams.get('location') || '',
    recordNbr: searchParams.get('recordNbr') || '',
    afNumber: searchParams.get('afNumber') || '',
    collection: searchParams.get('collection') || '',
    rfn: searchParams.get('rfn') || '',
    sourceBatch: searchParams.get('sourceBatch') || '',
    batchNbr: searchParams.get('batchNbr') || '',
    ord: searchParams.get('ord') || '',
    ordDate: searchParams.get('ordDate') || '',
    ordDateRange: searchParams.get('ordDateRange') || false,
    ordStartDate: searchParams.get('ordStartDate') || '',
    ordEndDate: searchParams.get('ordEndDate') || '',
    ordTemple: searchParams.get('ordTemple') || '',
  })
  const [date, setDate] = useState({
    key: 'date',
    primaryText: searchParams.get('date') || '',
  })
  const [startDate, setStartDate] = useState({
    key: 'startDate',
    primaryText: searchParams.get('startDate') || '',
  })
  const [endDate, setEndDate] = useState({
    key: 'endDate',
    primaryText: searchParams.get('endDate') || '',
  })
  const [ordDate, setOrdDate] = useState({
    key: 'ordDate',
    primaryText: searchParams.get('ordDate') || '',
  })
  const [ordStartDate, setOrdStartDate] = useState({
    key: 'ordStartDate',
    primaryText: searchParams.get('ordStartDate') || '',
  })
  const [ordEndDate, setOrdEndDate] = useState({
    key: 'ordEndDate',
    primaryText: searchParams.get('ordEndDate') || '',
  })
  const collectionTypes = {
    1: 'COF',
    5: 'GIANT',
    6: 'Family Entry',
    7: 'Pre-1970',
  }

  const idInput = (value) => {
    setQuery({ ...query, recordNbr: value, collection: collectionTypes[value[0]] })
  }

  const isEqual = (obj1, obj2) => {
    return (
      obj1.givenName === obj2.givenName &&
      obj1.surname === obj2.surname &&
      obj1.eventType === obj2.eventType &&
      obj1.date === obj2.date &&
      obj1.dateRange === obj2.dateRange &&
      obj1.startDate === obj2.startDate &&
      obj1.endDate === obj2.endDate &&
      obj1.location === obj2.location &&
      obj1.recordNbr === obj2.recordNbr &&
      obj1.afNumber === obj2.afNumber &&
      obj1.collection === obj2.collection &&
      obj1.rfn === obj2.rfn &&
      obj1.sourceBatch === obj2.sourceBatch &&
      obj1.batchNbr === obj2.batchNbr &&
      obj1.ord === obj2.ord &&
      obj1.ordDate === obj2.ordDate &&
      obj1.ordDateRange === obj2.ordDateRange &&
      obj1.ordStartDate === obj2.ordStartDate &&
      obj1.ordEndDate === obj2.ordEndDate &&
      obj1.ordTemple === obj2.ordTemple
    )
  }

  useEffect(() => {
    if (searchParams.get('search') === 'odmRecords' && !isEqual(query, initialState)) {
      handleSubmit(query)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search])

  const resetQuery = () => {
    history.push(`/search/odv`)
    setQuery(initialState)
    setDate({
      key: 'date',
      primaryText: '',
    })
    setStartDate({
      key: 'startDate',
      primaryText: '',
    })
    setEndDate({
      key: 'endDate',
      primaryText: '',
    })
    setOrdDate({
      key: 'ordDate',
      primaryText: '',
    })
    setStartDate({
      key: 'ordStartDate',
      primaryText: '',
    })
    setEndDate({
      key: 'ordEndDate',
      primaryText: '',
    })
    handleSubmit(null)
  }

  const setDateValue = (value) => {
    if (value) {
      setDate(value)
      setQuery({ ...query, date: value.primaryText })
    } else {
      date.primaryText = ''
      setDate(date)
      setQuery({ ...query, date: '' })
    }
  }

  const setStartDateValue = (value) => {
    if (value) {
      setStartDate(value)
      setQuery({ ...query, startDate: value.primaryText })
    } else {
      startDate.primaryText = ''
      setStartDate(startDate)
      setQuery({ ...query, startDate: '' })
    }
  }

  const setEndDateValue = (value) => {
    if (value) {
      setEndDate(value)
      setQuery({ ...query, endDate: value.primaryText })
    } else {
      endDate.primaryText = ''
      setEndDate(endDate)
      setQuery({ ...query, endDate: '' })
    }
  }

  const setOrdinanceDate = (value) => {
    if (value) {
      setOrdDate(value)
      setQuery({ ...query, ordDate: value.primaryText })
    } else {
      ordDate.primaryText = ''
      setOrdDate(ordDate)
      setQuery({ ...query, ordDate: '' })
    }
  }

  const setOrdStartDateValue = (value) => {
    if (value) {
      setOrdStartDate(value)
      setQuery({ ...query, ordStartDate: value.primaryText })
    } else {
      ordStartDate.primaryText = ''
      setOrdStartDate(startDate)
      setQuery({ ...query, ordStartDate: '' })
    }
  }

  const setOrdEndDateValue = (value) => {
    if (value) {
      setOrdEndDate(value)
      setQuery({ ...query, ordEndDate: value.primaryText })
    } else {
      ordEndDate.primaryText = ''
      setOrdEndDate(endDate)
      setQuery({ ...query, ordEndDate: '' })
    }
  }

  const toggleRange = (isRange) => {
    if (isRange) {
      setQuery({
        ...query,
        startDate: startDate.primaryText,
        endDate: endDate.primaryText,
        date: '',
        dateRange: true,
      })
    } else {
      setQuery({
        ...query,
        date: date.primaryText.replace('%', '').trim(),
        startDate: '',
        endDate: '',
        dateRange: false,
      })
    }
  }

  const toggleOrdRange = (isRange) => {
    if (isRange) {
      setQuery({
        ...query,
        ordStartDate: ordStartDate.primaryText,
        ordEndDate: ordEndDate.primaryText,
        ordDate: '',
        ordDateRange: true,
      })
    } else {
      setQuery({
        ...query,
        ordDate: ordDate.primaryText.replace('%', '').trim(),
        ordStartDate: '',
        ordEndDate: '',
        ordDateRange: false,
      })
    }
  }

  const submit = (event) => {
    event.preventDefault()
    let queryString = `search=odmRecords`

    Object.keys(query).forEach((queryKey) => {
      if (query[queryKey] !== initialState[queryKey]) {
        queryString += `&${queryKey}=${encodeURIComponent(query[queryKey])}`
      }
    })

    if (queryString !== `search=odmRecords`) {
      history.push(`/search/odv?${queryString}`)
    }
  }

  return (
    <form onSubmit={(event) => submit(event)}>
      <Divider />
      <Grid guttersY="nano">
        <Cell columns={5}>
          <TextField
            id="odmRecordGivenName"
            label={`${t('givenName', 'Given Name')}`}
            placeholder={t('odv.helper.wildcard', '% can be used as wildcard')}
            value={query.givenName}
            onChange={(event) => setQuery({ ...query, givenName: event.target.value })}
            autoFocus
          />
        </Cell>
        <Cell columns={5}>
          <TextField
            label={t('name.parts.surname', 'Surname')}
            placeholder={t('odv.helper.wildcard', '% can be used as wildcard')}
            value={query.surname}
            onChange={(event) => setQuery({ ...query, surname: event.target.value })}
          />
        </Cell>
        <Cell columns={3}>
          <TextField
            label={t('place', 'Place')}
            placeholder={t('odv.helper.wildcard', '% can be used as wildcard')}
            value={query.location}
            onChange={(event) => setQuery({ ...query, location: event.target.value })}
          />
        </Cell>
        <Cell columns={2}>
          <OdvEventSelect
            label={t('event', 'Event')}
            country="odm"
            placeholder={t('form.event.placeholder', 'Select Event')}
            value={query.eventType}
            onChange={(value) => setQuery({ ...query, eventType: value })}
          />
        </Cell>
        <Cell columns={1} alignY="middle">
          <Checkbox
            id="odmRecordEventRangeCheckbox"
            name="Range"
            label={t('range', 'Range')}
            checked={query.dateRange}
            onChange={(event) => toggleRange(event.target.checked)}
          />
        </Cell>
        <Cell columns={query.dateRange ? 'hide' : 4}>
          <DmcDatePicker
            idType="odmRecordEvent"
            selectedItem={date}
            setSelectedItem={setDateValue}
            label={t('date', 'Date')}
            dayMonthYearDateFormat="yyyyMMDD"
            monthYearDateFormat="yyyy"
            yearDateFormat="yyyy"
          />
        </Cell>
        <Cell columns={query.dateRange ? 2 : 'hide'}>
          <DmcDatePicker
            idType="odmRecordEventStart"
            selectedItem={startDate}
            setSelectedItem={setStartDateValue}
            label={t('startDate', 'Start Date')}
            dayMonthYearDateFormat="yyyyMMDD"
            monthYearDateFormat="yyyy"
            yearDateFormat="yyyy"
          />
        </Cell>
        <Cell columns={query.dateRange ? 2 : 'hide'}>
          <DmcDatePicker
            idType="odmRecordEventEnd"
            selectedItem={endDate}
            setSelectedItem={setEndDateValue}
            label={t('endDate', 'End Date')}
            dayMonthYearDateFormat="yyyyMMDD"
            monthYearDateFormat="yyyy"
            yearDateFormat="yyyy"
          />
        </Cell>
        <Divider />
        <Cell columns={2}>
          <TextField
            label={t('odv.nameId', 'Name ID')}
            type="number"
            value={query.recordNbr}
            onChange={(event) => idInput(event.target.value)}
          />
        </Cell>
        <Cell columns={2}>
          <OdvCollectionSelect
            value={query.collection}
            onChange={(value) => setQuery({ ...query, collection: value })}
          />
        </Cell>
        <Cell columns={2}>
          <TextField
            label={t('odv.rfn', 'RFN')}
            value={query.rfn}
            onChange={(event) => setQuery({ ...query, rfn: event.target.value })}
          />
        </Cell>
        <Cell columns={2}>
          <TextField
            label={t('odv.sourceBatchNumber', 'Source Batch #')}
            value={query.sourceBatch}
            onChange={(event) => setQuery({ ...query, sourceBatch: event.target.value })}
          />
        </Cell>
        <Cell columns={2}>
          <TextField
            label={t('odv.processBatchNumber', 'Process Batch #')}
            value={query.batchNbr}
            onChange={(event) => setQuery({ ...query, batchNbr: event.target.value })}
          />
        </Cell>
        <Divider />
        <Cell columns={2}>
          <OdvOrdinanceSelect
            label={t('odv.ordinance', 'Ordinance')}
            placeholder={t('odm.ordinance.select', 'Select Ordinance')}
            country="odm"
            value={query.ord}
            onChange={(value) => setQuery({ ...query, ord: value })}
          />
        </Cell>
        <Cell columns={1} alignY="middle">
          <Checkbox
            id="odmRecordOrdRangeCheckbox"
            name="ordDateRange"
            label={t('range', 'Range')}
            checked={query.ordDateRange}
            onChange={(event) => toggleOrdRange(event.target.checked)}
          />
        </Cell>
        <Cell columns={query.ordDateRange ? 'hide' : 4}>
          <DmcDatePicker
            idType="odmRecordOrd"
            selectedItem={ordDate}
            setSelectedItem={setOrdinanceDate}
            label={t('date', 'Date')}
            dayMonthYearDateFormat="yyyyMMDD"
            monthYearDateFormat="yyyy"
            yearDateFormat="yyyy"
          />
        </Cell>
        <Cell columns={query.ordDateRange ? 2 : 'hide'}>
          <DmcDatePicker
            idType="odmRecordOrdStart"
            selectedItem={ordStartDate}
            setSelectedItem={setOrdStartDateValue}
            label={t('startDate', 'Start Date')}
            dayMonthYearDateFormat="yyyyMMDD"
            monthYearDateFormat="yyyy"
            yearDateFormat="yyyy"
          />
        </Cell>
        <Cell columns={query.ordDateRange ? 2 : 'hide'}>
          <DmcDatePicker
            idType="odmRecordOrdEnd"
            selectedItem={ordEndDate}
            setSelectedItem={setOrdEndDateValue}
            label={t('endDate', 'End Date')}
            dayMonthYearDateFormat="yyyyMMDD"
            monthYearDateFormat="yyyy"
            yearDateFormat="yyyy"
          />
        </Cell>
        <Cell columns={3}>
          <DmcTemplePicker
            templeCode={query.ordTemple}
            onSuggestionSelected={(selection) => selection && setQuery({ ...query, ordTemple: selection.templeCode })}
            onClear={() => setQuery({ ...query, ordTemple: '' })}
          />
        </Cell>
        <Divider />
        <Cell columns={1}>
          <Button id="odvSearchBtn" type="submit" emphasis="high">
            {t('action.search', 'Search')}
          </Button>
        </Cell>
        <Cell columns={11}>
          <Button emphasis="medium" onClick={resetQuery}>
            {t('action.clear', 'Clear')}
          </Button>
        </Cell>
      </Grid>
    </form>
  )
}
